export default __webpack_public_path__ + "static/media/placeholder10.e9f8bebc.jpg";